import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FloorInfo, TableDetailForOrder } from "@royalty/model";
import { AppUtils } from "src/app/core/utils/app-utils";
import { BehaviorSubject } from "rxjs";
import { SignalRService } from "src/app/core/websocket/signalr.service";

const URL_HUB = "/poshub";


@Injectable()
export class PosHubSignalRService extends SignalRService {
	syncFloorsChanged$ = new BehaviorSubject<FloorInfo[]>(null);
	noticeTableIsCreatedChanged$ = new BehaviorSubject<TableDetailForOrder>(
		null
	);
	noticeTableIsUpdatedChanged$ = new BehaviorSubject<TableDetailForOrder>(
		null
	);
	noticeTableIsDeletedChanged$ = new BehaviorSubject<TableDetailForOrder>(
		null
	);

	constructor(protected http: HttpClient) {
		super(http);
		this.createConnection(URL_HUB, {
			withAutomaticReconnect: AppUtils.isMobileApp,
		});
		this.registerOnServerEvents();
		this.startConnection();
	}

	registerOnServerEvents(): void {

		this.hubConnection.on("SyncFloors", (data: FloorInfo[]) => {
			this.syncFloorsChanged$.next(data);
		});
		this.hubConnection.on(
			"NoticeTableIsCreated",
			(data: TableDetailForOrder) => {
				this.noticeTableIsCreatedChanged$.next(data);
			}
		);
		this.hubConnection.on(
			"NoticeTableIsUpdated",
			(data: TableDetailForOrder) => {
				this.noticeTableIsUpdatedChanged$.next(data);
			}
		);
		this.hubConnection.on(
			"NoticeTableIsDeleted",
			(data: TableDetailForOrder) => {
				this.noticeTableIsDeletedChanged$.next(data);
			}
		);
	}
}
